module.exports = __webpack_public_path__ + "media/images/missing/participant-0704ace42882b02c81d29de6ba02582c.png";